import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AdMobileBannerComponent,
  MobileDetectService,
  PostFeedInterfaceLastId,
  PostFeedService,
  PostModel,
  PostsService,
  RouterService,
  UserModel,
  UserService,
  utilsFactory,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-feed',
  templateUrl: './profile-feed.component.html',
  styleUrls: ['./profile-feed.component.scss'],
})
export class ProfileFeedComponent implements OnInit, OnDestroy {
  @ViewChild('headerAdvertisement')
  headerAdvertisement: AdMobileBannerComponent;

  profile: UserModel = null;
  postsList: Array<PostModel> = [];

  fistLoad = true;
  loadingPosts = false;
  feedError = false;
  noFeed = false;

  currentGoBackUrl = null;
  backPathReferrer = null;
  backFallbackReferrer = null;

  isMobile = true;
  isDesktop = false;

  hideCloseButton = false;

  // postPagination: LastIdPaginationFactory = null;
  postFeedControl: PostFeedInterfaceLastId = null;

  onRouteChangeSubscriber = null;

  constructor(
    private postsService: PostsService,
    private routerService: RouterService,
    private userService: UserService,
    private mobileDetectService: MobileDetectService,
    private postFeedService: PostFeedService,
  ) {
    this.isMobile = this.mobileDetectService.isMobile();
    this.isDesktop = !this.mobileDetectService.isMobile();
  }

  async ngOnInit() {
    try {
      // console.log('profile-feed.component->ngOnInit(): this.postsList', this.postsList);

      this.currentGoBackUrl = this.routerService.getCurrentUrl();
      // console.log('profile-feed.component->ngOnInit(): this.currentGoBackUrl', this.currentGoBackUrl);

      this.backPathReferrer = this.routerService.getGoBackReferer(this.currentGoBackUrl);
      // console.log('profile-feed.component->ngOnInit(): this.backPathReferrer', this.backPathReferrer);

      this.onRouteChangeSubscriber = this.routerService.onRouteChange().subscribe(async (route) => {
        // console.log('profile-feed.component->ngOnInit(): onRouteChange() route', route);

        try {
          const routeParams = route.params;
          // console.log('profile-feed.component->ngOnInit() routeParams', routeParams);

          this.profile = await this.userService.getUser(route.params.userId);
          // console.log('profile-feed.component->ngOnInit() this.profile', this.profile);

          if (!this.profile) {
            throw new Error(`Couldn't get the profile UserModel object`);
          }

          if (!this.backPathReferrer) {
            this.backFallbackReferrer = `/@${this.profile.username}`;
            // console.log('profile-feed.component->ngOnInit(): this.backFallbackReferrer', this.backFallbackReferrer);
          }

          this.postFeedControl = this.postFeedService.registerFeedLastIdPagination(
            `profile-feed-${this.profile.id}`,
            this.profile.getPosts.bind(this.profile),
            { limit: 5 },
          );
          // console.log('profile-feed.component->ngOnInit() this.postFeedControl', this.postFeedControl);

          this.postsList = this.postFeedControl.postsList;
          // console.log('profile-feed.component->ngOnInit() this.postsList BEFORE', this.postsList);

          if (this.postsList.length) {
            if (routeParams.postId) {
              let isThePostOnListAlready = false;

              for (const post of this.postsList) {
                // console.log('profile-feed.component->ngOnInit() post.id === routeParams.postId', post.id, parseInt(routeParams.postId, 10));

                if (post.id === parseInt(routeParams.postId, 10)) {
                  isThePostOnListAlready = true;
                  break;
                }
              }

              // console.log('profile-feed.component->ngOnInit() isThePostOnListAlready', isThePostOnListAlready);

              if (isThePostOnListAlready) {
                return;
              }
            }
          }

          if (routeParams.postId) {
            const firstPost = await this.postsService.getPost(routeParams.postId);
            // console.log('profile-feed.component->ngOnInit(): firstPost', routeParams.postId, firstPost);

            this.postsList.unshift(firstPost);
            // console.log('profile-feed.component->ngOnInit(): this.postsList: AFTER', this.postsList);
          }

          if (utilsFactory.isBrowser) {
            // console.log('profile-feed.component->ngOnInit(): this.getPosts()');
            await this.getPosts();
          }
        } catch (e) {
          if (e['code'] === 404 || e['code'] === 405) {
            await this.routerService.navigateTo('/404', {
              skipLocationChange: true,
            });
          } else if (e['code'] >= 500) {
            await this.routerService.navigateTo('/error', {
              skipLocationChange: true,
            });
          }
        }
      });
      
    } catch (e) {
      console.error('profile-feed.component->ngOnInit(): ERROR: ', e);
      this.postsList = [];
    }
  }

  ngOnDestroy() {
    /*if (this.postPagination) {
		 this.postPagination.destroy();
		 }*/

    if (this.onRouteChangeSubscriber) {
      this.onRouteChangeSubscriber.unsubscribe();
    }
  }

  onSlideChange(section) {
    if (this.headerAdvertisement) {
      // console.log('profile-feed.component->onSlideChange()', section);
      this.headerAdvertisement.refreshAd();
    }
  }

  onPostAdFill(type) {
    // console.log('profile-feed.component->onPostAdFill(): type', type);

    if (this.isMobile) {
      this.hideCloseButton = true;
    }
  }

  onPostAdHide(type) {
    // console.log('profile-feed.component->onPostAdHide(): type', type);

    if (this.isMobile) {
      this.hideCloseButton = false;
    }
  }

  onPostHeaderToggle(isOpen) {
    // console.log('profile-feed.component->onPostHeaderToggle(): isOpen', isOpen);
    this.hideCloseButton = isOpen;
  }

  async getPosts() {
    try {
      // console.log('profile-feed.component->getPosts(): this.loadingPosts', this.loadingPosts);

      if (this.loadingPosts) {
        await utilsFactory.waitToBeTrue('profile-feed.component', () => this.loadingPosts === false);

        /*await new Promise(resolve => {
				 const intervalTimer = setInterval(() => {
				 if (this.loadingPosts === false) {
				 clearInterval(intervalTimer);
				 resolve();
				 }
				 }, 100);
				 });*/
      }

      this.feedError = false;
      this.loadingPosts = true;

      await this.postFeedControl.pagination.getItems();
      // console.log('profile-feed.component->getPosts(): this.postsList', this.postsList);

      if (this.postsList.length === 0) {
        this.noFeed = true;
      }

      this.loadingPosts = false;

      // console.log('profile-feed.component->getPosts(): this.postsList', this.postsList);
    } catch (e) {
      console.error('profile-feed.component->getPosts(): ERROR', e);

      this.loadingPosts = false;
      this.feedError = true;
      throw e;
    }
  }
}
